module.exports = __webpack_public_path__ + "media/images/no-image-2774f4b4.jpeg";